import * as Styles from './CandidateSortOrder.styles';

export type CandidateSortOrderProps = {
  onUpdateSortBy: (event) => void;
  order: string;
  isBigger?: boolean;
};

const CandidateSortOrder = ({
  onUpdateSortBy,
  order,
  isBigger = true,
}: CandidateSortOrderProps): JSX.Element => {
  return (
    <Styles.CustomDropdown
      isBigger={isBigger}
      name="order"
      isLabelAboveField
      onChangeDropDown={onUpdateSortBy}
      defaultValue={order}
      optionsWithLabel={[
        {
          value: 'ASC',
          label: '↑',
        },
        {
          value: 'DESC',
          label: '↓',
        },
      ]}
    />
  );
};

export default CandidateSortOrder;
